module.exports = require("github:jspm/nodelibs-https@0.1.0/index");